import {Directive, ElementRef, HostListener, Input, OnChanges, SimpleChanges} from '@angular/core';
import {NodeDetails} from "../../services/flowBuilder/models";

@Directive({
    selector: '[flowNode]'
})
export class FlowNodeDirective implements OnChanges {

    node: HTMLElement
    isNodeSelected: boolean;

    @Input('nodeDetail') nodeDetail: NodeDetails;
    @Input('selected') selected: string;

    constructor(private el: ElementRef) {
        this.node = this.el.nativeElement;
        this.backgroundImg()
    }

    ngOnChanges(changes: SimpleChanges){
        if(changes.selected){
            this.isSelected()
        }
    }

    @HostListener('mouseenter') onHover() {
        if (this.isNodeSelected) {
            return
        }
        if (this.nodeDetail.nodeType === 'chatHub') {
            this.node.style.background = `url(${this.nodeDetail.canvas.backgroundImgHover}) 10px 10px no-repeat`;
        } else {
            this.node.style.background = `url(${this.nodeDetail.canvas.backgroundImgHover}) no-repeat left top`;
        }
    }

    @HostListener('mouseleave') onLeave() {
        this.isSelected()
    }

    private isSelected(): boolean {
        if (this.nodeDetail.nodeId !== this.selected) {
            this.isNodeSelected = false
            this.backgroundImg()
            return
        }

        this.node.style.background = `url(${this.nodeDetail.canvas.backgroundImgSelected}) no-repeat 10px 10px`;
        this.isNodeSelected = true
    }

    private backgroundImg() {
        if (this.nodeDetail) {
            this.node.style.background = `url(${this.nodeDetail.canvas.backgroundImg}) no-repeat 10px 10px`;
        }
    }
}
